define('Components/Loyalty/js/Loyalty',['hooks','app',
    'Components/Loyalty/js/views/blocks/LoyaltyProfileView',
    'Components/Loyalty/js/views/blocks/CartDeliveryDataView',
],function(
        hooks,app,
        LoyaltyProfileView,
        CartDeliveryDataView,
        CartCagnottageTemplate
    ){
    return function(){

        var registerHook = hooks.registerHook;

        registerHook('useCagnotte',function(option, callback){
            callback.call(null, true);
        });

        registerHook('formatCagnotte',function(amount, callback){
            callback.call(null, amount.toString());
        });

        registerHook('LoyaltyProfileView', function (options, callback) {
            callback.call(null, LoyaltyProfileView);
        });

        registerHook('getCagnotteConversionRate', function (customerModel, callback) {
            callback.call(null, getRatio());
        });

        function getRatio(){
            return app.c('_RATIO_SWAP_PTS_AMOUNT_', 1) / 100;
        }

        registerHook('hookCheckoutCagnottageDataView', function(options){
            options.view.appendView(CartDeliveryDataView,options.selector,_.pick(options,['cart','context']));
        })

        registerHook('getFidelityComponentTheme', function(options, callback){
            callback.call(null, 'theme-loyalty');
        })
    }
});
